import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { getAuth, createUserWithEmailAndPassword, updateProfile } from 'firebase/auth'
import { setDoc, doc, serverTimestamp} from 'firebase/firestore'
import { db } from '../firebase-config'
import {toast} from 'react-toastify'
import visibilityIcon from '../assets/svg/visibilityIcon.svg'
import '../Styles/SignUp.css'



function SignUp() {
  const [showPassword, setShowpassword] = useState(false)

    const userTypes = [
      { label: "Worker", value: "worker" },
      { label: "HR", value: "isHr" },
      { label: "Månedsrapport", value: "isMonth" },
    ];

    const [formData, setFormData] = useState({
      name: '',
      email: '',
      password: '',
      company: '',
      userType: userTypes[0].value,
      isAdmin: false
    });

  const { name, email, password, company, userType, isAdmin } = formData
  
  const navigate = useNavigate()
  const onChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: value,
    }));
  }
  

  const onSubmit = async (e) => {
    e.preventDefault();
    try{
      const auth = getAuth()
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const newUser = userCredential.user;
      updateProfile(auth.currentUser, {
        displayName: name,
      })
      const formDataCopy = {...formData}
      delete formDataCopy.password
      formDataCopy.timestamp = serverTimestamp()

      await setDoc(doc(db, 'users', newUser.uid), formDataCopy)

      navigate('/')
    }catch (error) {
      toast.error('Noget gik galt under oprettelsen')
    }
  }
  const onBackClick = () => {
    navigate('/admin-panel')
  }

  return (
    <>
        <div className="container sign-up-container">
            <h1 className="main-header">Opret Bruger</h1>
            <form onSubmit={onSubmit} className="sign-up-form">
                <input 
                    type="text" 
                    className="nameInput border" 
                    placeholder="Navn" 
                    id="name" 
                    value={name} 
                    onChange={onChange} />
                <div className="emailInputDiv">
                    
                    <input 
                        type="email" 
                        className="border emailInput" 
                        placeholder="Email" 
                        id="email" 
                        value={email} 
                        onChange={onChange} 
                    />
                </div>
                <div className="companyInputDiv">
                <input 
                    type="text" 
                    className="border companyInput" 
                    placeholder="Firma" 
                    id="company" 
                    value={company} 
                    onChange={onChange} 
                />
                </div>
                          <div className="UserTypeInput">
                  <label htmlFor="userType">Bruger Type</label>
                  <select 
                    className="border userTypeInput" 
                    id="userType" 
                    value={userType} 
                    onChange={onChange}>
                    {userTypes.map((type, index) => (
                      <option key={index} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="passwordInputDiv">
                    <input 
                        type={showPassword ? 'text' : 'password'}
                        className="passwordInput"
                        placeholder="Password"
                        id="password" 
                        value={password} 
                        onChange={onChange} 
                    />
                    <img 
                        src={visibilityIcon} 
                        alt="show password" 
                        className="showPassword" 
                        onClick={() => setShowpassword((prevState) => !prevState)} 
                    />
                </div>
                  <div className="adminCheckboxDiv">
                <input 
                  className="adminCheckbox"
                  type="checkbox" 
                  id="isAdmin" 
                  checked={isAdmin} 
                  onChange={(e) => setFormData(prevState => ({ ...prevState, isAdmin: e.target.checked }))} 
                />
                <label htmlFor="isAdmin">Admin rettigheder?</label>
              </div>

                <button className="sign-up-btn mb-1">Opret Bruger</button>
                <button className="back-btn" onClick={onBackClick}>Tilbage</button>
            </form>
        </div>
    </>
);
}

export default SignUp